import {menus} from "../../../../helpers/menu";
import {Box, List, ListItemIcon, ListItemText, useMediaQuery} from "@mui/material";
import {fnLocalizeFilter} from "../../../../services/localize.service";
import {useGlobalContext} from "../../../../services/context.service";
import {NavLink, useLocation, useNavigate} from "react-router-dom";
import {styled} from "@mui/material/styles";
import {makeStyles} from "@mui/styles";
import {Theme} from "@mui/material/styles/createTheme";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import {userLogout} from "../../../../store/actions/userAction";
import {useAppDispatch} from "../../../../hooks/redux";
import {getMedia} from "../../../../helpers/media";
import {useEffect, useState} from "react";
import {hoverLink} from "../../../../style/global";
import {checkPermission} from "../../../../helpers/permissions";
import {getConfigFromFile, getDataFromLocalStorage} from "../../../../utils/methods";
import {IConfig} from "../../../../utils/interface";

const DrawerHeader = styled('div')(({theme}) => ({
    display: 'flex', alignItems: 'center', justifyContent: 'flex-end', padding: theme.spacing(0, 1), // necessary for content to be below app bar
    ...theme.mixins.toolbar,
}));

const MenuItem = styled(List)((theme) => ({
    display: 'flex',

}));


const useStyles = makeStyles<Theme>((theme) => ({
    activeLink: {
        textDecoration: "inherit",
        display: "flex",
        width: "100%",
        backgroundColor: "rgba(200,200,200,0.2)",
        "& hover": {
            ...hoverLink
        }
    }
}));

const NavLinkColored = styled((props: any) => <NavLink  {...props}/>)((props) => {
    const {state} = props;
    return ({
        textDecoration: "inherit", display: "flex", width: "100%", ...state
    })
});

export default function Menu() {

    const {locale} = useGlobalContext();
    const location = useLocation();
    const classes = useStyles();
    const dispatch = useAppDispatch();
    const matches = useMediaQuery(getMedia());
    const navigate = useNavigate();

    const [colored, setColor] = useState({
        text: "#ccc", hoverColor: "#9b9b9b"
    });


    useEffect(() => {
        getConfigFromFile().then(setting => {
            const color = setting.config.menu?.link.color;
            color && setColor({
                text: color.text, hoverColor: color.hover
            });
        })
    }, [])

    useEffect(() => {
        let role: string = getDataFromLocalStorage('role') as string;
        /*  */
        if (role === "SmartCardsDriver") navigate('./driver/cards'); else if (location.pathname === `/`) navigate('./clients');
        getConfigFile().then()
    }, [])

    const [config, setConfig] = useState<IConfig>();

    const getConfigFile = async () => {
        setConfig(await getConfigFromFile());
    };

    const logout = () => {
        dispatch(userLogout());
    };


    return <Box width={"100%"}>


        {menus.filter(menu => !!menu.icon && menu.permission && checkPermission({
            permissionName: menu.permission, notShowPermission: menu.notShowPermission, configFile: config
        }) > 0).map(menu => (<NavLinkColored key={menu.link} to={`./${menu.linkApp}`}
                                             className={menu.linkRegExp && menu.linkRegExp.test(location.pathname) && classes.activeLink}
                                             state={{color: colored.text, "&:hover": {color: colored.hoverColor}}}
        >
            <MenuItem key={menu.link}>
                <ListItemIcon
                    sx={{minWidth: "25px", margin: "0 .7rem", color: "inherit"}}>{menu.icon}</ListItemIcon>
                <ListItemText color="inherit" primary={fnLocalizeFilter(locale, `${menu.title}`)}/>
            </MenuItem>
        </NavLinkColored>))}
        <NavLinkColored state={{color: colored.text, "&:hover": {color: colored.hoverColor}}} to={"./"}>
            <MenuItem onClick={logout}>
                <ListItemIcon
                    sx={{minWidth: "25px", margin: "0 .7rem", color: "inherit"}}><ExitToAppIcon/></ListItemIcon>
                <ListItemText color="inherit" primary={fnLocalizeFilter(locale, '_lang.module.login.btnLogout')}/>
            </MenuItem>
        </NavLinkColored>
    </Box>
}
